import {
  LayoutDashboard, ArrowLeftRight, Wallet, CalendarRange, Gauge,
  Landmark, Target, ShoppingBag, ShoppingCart, Sparkles, TrendingUp,
  ShieldCheck, Settings2, FileText, Compass, CalendarCheck, BarChart3, BookOpen, ClipboardCheck, CalendarRange as CalRange,
} from "lucide-react";

export const NAV = [
  { key: "overview", label: "Overview", to: "/wealth", icon: LayoutDashboard },
  { key: "cash-flow", label: "Cash flow", to: "/wealth/cash-flow", icon: ArrowLeftRight },
  { key: "budget", label: "Budget & bills", to: "/wealth/budget", icon: Wallet },
  { key: "life-plan", label: "Life plan", to: "/wealth/life-plan", icon: CalendarRange },
  { key: "credit", label: "Credit", to: "/wealth/credit", icon: Gauge },
  { key: "accounts", label: "Accounts & debt", to: "/wealth/accounts", icon: Landmark },
  { key: "goals", label: "Goals", to: "/wealth/goals", icon: Target },
  { key: "purchase-planner", label: "Purchase planner", to: "/wealth/purchase-planner", icon: ShoppingBag },
  { key: "grocery", label: "Grocery intelligence", to: "/wealth/grocery", icon: ShoppingCart },
  { key: "advisor", label: "AI wealth advisor", to: "/wealth/advisor", icon: Sparkles },
  { key: "wealth-plan", label: "Wealth plan", to: "/wealth/wealth-plan", icon: TrendingUp },
  { key: "protection", label: "Protection", to: "/wealth/protection", icon: ShieldCheck },
  { key: "settings", label: "Data & settings", to: "/wealth/settings", icon: Settings2 },
];

export const LIFE_NAV = [
  { key: "command", label: "Command", to: "/life", icon: LayoutDashboard },
  { key: "planning", label: "Life Planning", to: "/life/planning", icon: CalendarRange },
  { key: "areas", label: "Life Areas", to: "/life/areas", icon: Target },
  { key: "faith", label: "Faith & Character", to: "/life/faith", icon: BookOpen },
  { key: "reviews", label: "Reviews", to: "/life/reviews", icon: TrendingUp },
  { key: "command-ai", label: "Command AI", to: "/life/ai", icon: Sparkles },
];

export const WELLNESS_NAV = [
  { key: "command", label: "Command", to: "/wellness", icon: LayoutDashboard },
  { key: "plan", label: "Goals & Plan", to: "/wellness/plan", icon: Target },
  { key: "glow", label: "Glow & Presence", to: "/wellness/glow", icon: Sparkles },
  { key: "progress", label: "Progress", to: "/wellness/progress", icon: TrendingUp },
  { key: "reviews", label: "Reviews", to: "/wellness/reviews", icon: CalendarRange },
  { key: "strategist", label: "Wellness AI", to: "/wellness/ai", icon: Gauge },
];

export const CENTRAL_NAV = [
  { key: "overview", label: "Overview", to: "/central", icon: Compass },
  { key: "pillars", label: "Pillars", to: "/central/pillars", icon: BarChart3 },
  { key: "digest", label: "Weekly Digest", to: "/central/digest", icon: CalendarCheck },
  { key: "reports", label: "Reports", to: "/central/reports", icon: FileText },
  { key: "ai", label: "Strategist AI", to: "/central/ai", icon: Sparkles },
];

export const RHYTHM_NAV = [
  { key: "review", label: "Weekly Review", to: "/rhythm", icon: ClipboardCheck },
  { key: "plan", label: "Weekly Plan", to: "/rhythm/plan", icon: CalRange },
];
